import '@reown/appkit-polyfills';
export { WagmiAdapter } from './client.js';
export { authConnector } from './connectors/AuthConnector.js';
//# sourceMappingURL=index.js.map